<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <header-partial :domain="domain" />

                <div class="page-block">
                    <technical-management-tabs :step="4" :domain="domain" :service="firstServiceForDomain" />

                    <ssl-wrapper :domain="domain" :subscriptions="services" />
                    <div v-if="canOrder" class="page-block__item-wrapper">
                        <div class="layout | u-text-right">
                            <div class="layout__item u-1/4-desk">
                                <customer-router-link :to="{ name: 'orderSslSelect', params: { domain: domain } }">
                                    <button type="button" class="btn btn--ghost btn--ghost-full-width" dusk="order-ssl">
                                        {{ trans('ssl.order') }}
                                    </button>
                                </customer-router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { SslWrapper } from 'relapp-ssl';
import { HeaderPartial, serviceMixin, servicesPageMixin } from 'relapp-technical-management';

export default {
    components: {
        HeaderPartial,
        SslWrapper
    },
    mixins: [serviceMixin, servicesPageMixin],
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            serviceType: 'ssl'
        };
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.getServices();
    },
    /**
     * Get the meta info for the page.
     *
     * @return {object}
     */
    metaInfo() {
        return {
            title: trans('page.ssl.title', { domain: this.domain })
        };
    }
};
</script>
